var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "css-grid battery-order-view__row" }, [
    _c("div", { staticClass: "css-grid battery-order-view__order" }, [
      _c("div", { staticClass: "battery-order-view__cell" }, [
        _vm._v("\n      " + _vm._s(_vm.product.battery_line) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "css-grid battery-order-view__order" }, [
      _c("div", { staticClass: "battery-order-view__cell" }, [
        _vm._v("\n      " + _vm._s(_vm.product.size) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "css-grid battery-order-view__order" }, [
      _c("div", { staticClass: "battery-order-view__cell" }, [
        _vm._v("\n      " + _vm._s(_vm.product.pack_option) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "css-grid battery-order-view__order" }, [
      _c("div", { staticClass: "battery-order-view__cell h-helper-text" }, [
        _vm._v("\n      " + _vm._s(_vm.product.description) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "css-grid battery-order-view__order" }, [
      _c("div", { staticClass: "battery-order-view__cell" }, [
        _vm._v("\n      " + _vm._s(_vm.product.imprint) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "css-grid battery-order-view__order" }, [
      _c("div", { staticClass: "battery-order-view__cell h-center-align" }, [
        _vm._v("\n      " + _vm._s(_vm.product.quantity) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "css-grid battery-order-view__order" }, [
      _c("div", { staticClass: "battery-order-view__cell h-center-align" }, [
        _vm._v("\n      " + _vm._s(_vm.itemPrice) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "css-grid battery-order-view__order" }, [
      _c("div", { staticClass: "battery-order-view__cell h-center-align" }, [
        _vm._v("\n      " + _vm._s(_vm.totalBatteries) + " batteries\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "css-grid battery-order-view__order" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: { content: "Remove Product from Cart" },
              expression: "{ content: 'Remove Product from Cart' }"
            }
          ],
          staticClass:
            "battery-order-view__cell battery-order-view__cell--remove h-center-align"
        },
        [
          _c("span", {
            staticClass: "glyphicon glyphicon-remove",
            attrs: { "aria-hidden": "true" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.removeItem($event)
              }
            }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }